const $c3f0c132b8695422$var$STATE = {
    DISAPPEAR: 0,
    NOTHING: 1,
    APPEAR: 2,
    PENDING: 3,
    DISAPPEAR_RESTART: 4
};
const $c3f0c132b8695422$var$PERSIST_TIME = 150;
class $c3f0c132b8695422$export$b25a304ec7d746bb {
    constructor(options = {}){
        this._el = document.createElement("div");
        this._state = $c3f0c132b8695422$var$STATE.NOTHING;
        this._opts = {
            maxWidth: "99.8%",
            height: "4px",
            duration: 60000,
            hideDuration: 400,
            zIndex: "9999",
            color: "#ff1a59",
            className: "",
            timing: "cubic-bezier(0,1,0,1)",
            position: "top",
            container: document.body
        };
        this._rafId = null;
        this._timerId = null;
        this._promises = [];
        this._delayTimers = [];
        this._detachListeners = [];
        this.setOptions(options);
    }
    setOptions(newOptions) {
        const opts = $c3f0c132b8695422$var$assign(this._opts, newOptions);
        if (!isNaN(opts.maxWidth)) opts.maxWidth += "px";
        if (!isNaN(opts.height)) opts.height += "px";
        opts.zIndex = String(opts.zIndex);
        this._el.className = opts.className;
        this._css($c3f0c132b8695422$var$assign({
            height: opts.height,
            background: opts.color,
            zIndex: opts.zIndex,
            position: "",
            left: "",
            top: "",
            bottom: ""
        }, {
            top: {
                position: "fixed",
                top: "0",
                left: "0"
            },
            bottom: {
                position: "fixed",
                bottom: "0",
                left: "0"
            }
        }[opts.position]));
    }
    _css(style) {
        $c3f0c132b8695422$var$assign(this._el.style, style);
    }
    get isInProgress() {
        return this._state !== 0;
    }
    start() {
        switch(this._state){
            case $c3f0c132b8695422$var$STATE.APPEAR:
            case $c3f0c132b8695422$var$STATE.PENDING:
            case $c3f0c132b8695422$var$STATE.DISAPPEAR_RESTART:
                return;
            case $c3f0c132b8695422$var$STATE.DISAPPEAR:
                this._state = $c3f0c132b8695422$var$STATE.DISAPPEAR_RESTART;
                return;
        }
        this._state = $c3f0c132b8695422$var$STATE.APPEAR;
        const opts = this._opts;
        const transition = `width ${opts.duration}ms ${opts.timing}`;
        this._css({
            width: "0",
            opacity: "1",
            transition: transition,
            webkitTransition: transition
        });
        opts.container.appendChild(this._el);
        this._rafId = requestAnimationFrame(()=>{
            this._rafId = requestAnimationFrame(()=>{
                this._rafId = null;
                this._state = $c3f0c132b8695422$var$STATE.PENDING;
                this._css({
                    width: this._opts.maxWidth
                });
            });
        });
    }
    end(immediately = false) {
        this._promises = [];
        this._delayTimers.splice(0).forEach(clearTimeout);
        switch(this._state){
            case $c3f0c132b8695422$var$STATE.NOTHING:
                return;
            case $c3f0c132b8695422$var$STATE.APPEAR:
                this._state = $c3f0c132b8695422$var$STATE.NOTHING;
                cancelAnimationFrame(this._rafId);
                this._rafId = null;
                this._detach();
                return;
            case $c3f0c132b8695422$var$STATE.DISAPPEAR:
            case $c3f0c132b8695422$var$STATE.DISAPPEAR_RESTART:
                if (immediately) {
                    this._state = $c3f0c132b8695422$var$STATE.NOTHING;
                    clearTimeout(this._timerId);
                    this._timerId = null;
                    this._detach();
                } else this._state = $c3f0c132b8695422$var$STATE.DISAPPEAR;
                return;
        }
        if (immediately) {
            this._state = $c3f0c132b8695422$var$STATE.NOTHING;
            this._detach();
            return;
        }
        this._state = $c3f0c132b8695422$var$STATE.DISAPPEAR;
        const opts = this._opts;
        const transition = `width 50ms, opacity ${opts.hideDuration}ms ${$c3f0c132b8695422$var$PERSIST_TIME}ms`;
        this._css({
            width: "100%",
            opacity: "0",
            transition: transition,
            webkitTransition: transition
        });
        this._timerId = setTimeout(()=>{
            this._timerId = null;
            const restart = this._state === $c3f0c132b8695422$var$STATE.DISAPPEAR_RESTART;
            this._state = $c3f0c132b8695422$var$STATE.NOTHING;
            this._detach();
            if (restart) this.start();
        }, opts.hideDuration + $c3f0c132b8695422$var$PERSIST_TIME);
    }
    _detach() {
        this._detachListeners.splice(0).forEach((fn)=>fn());
        this._el.parentNode?.removeChild(this._el);
    }
    promise(p, { delay: delay = 0, min: min = 100, waitAnimation: waitAnimation = false } = {}) {
        let delayTid;
        const start = ()=>{
            if (min > 0) p = Promise.all([
                p,
                new Promise((res)=>setTimeout(res, min))
            ]).then(([v])=>v);
            this._promises.push(p);
            this.start();
        };
        const cleanupDelayTimer = ()=>{
            const timers = this._delayTimers;
            timers.splice(timers.indexOf(delayTid) >>> 0, 1);
            delayTid = null;
        };
        if (delay > 0) this._delayTimers.push(delayTid = setTimeout(()=>(cleanupDelayTimer(), start()), delay));
        else start();
        const next = (val)=>{
            if (delayTid) {
                clearTimeout(delayTid);
                cleanupDelayTimer();
                return val;
            }
            const ret = waitAnimation && this._state !== $c3f0c132b8695422$var$STATE.NOTHING ? new Promise((r)=>this._detachListeners.push(r)).then(()=>val) : val;
            const promises = this._promises;
            const idx = promises.indexOf(p);
            if (~idx) {
                promises.splice(idx, 1);
                if (promises.length === 0) this.end();
            }
            return ret;
        };
        return p.then(next, (err)=>next(Promise.reject(err)));
    }
}
function $c3f0c132b8695422$var$assign(target, src) {
    for(const k in src)if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k];
    return target;
}


window.progress = new (0, $c3f0c132b8695422$export$b25a304ec7d746bb)({
    height: 5
});
window.delay = (ms)=>new Promise((res)=>setTimeout(res, ms));


//# sourceMappingURL=index.e3b655d1.js.map
